import { useState } from 'react';
import useAttendanceProofGroupConfig from './AttendanceProofGroup.config';

const useAttendanceProofGroup = () => {
  const config = useAttendanceProofGroupConfig();
  const [showRetroactiveWarning, setShowRetroactiveWarning] = useState(false);

  const handleSignatureCollectionChange = (_name: string, checked: boolean) => {
    setShowRetroactiveWarning(checked && config.signatureCollection.showRetroactiveWarning);
  };

  return {
    config,
    showRetroactiveWarning,
    handleSignatureCollectionChange,
  };
};

export default useAttendanceProofGroup;
